import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      'The world\'s 1st eGeeTouch® smart luggage locks assembled on check-in luggage and hand-carry suitcase had been put to multiple tests for over a year from May 2014 to June 2015 in actual "live" road tests through various international airports and airlines and performed tremendously well in both functional and physical integrity. For more info on Tests & Certifications, ',
    reply2: "click here",
    back: "Back",
  },
  ja: {
    reply1:
      "チェックイン手荷物と機内持ち込みスーツケースに組み込まれた世界初の eGeeTouch® スマート手荷物ロックは、2014 年 5 月から 2015 年 6 月までの 1 年以上にわたり、さまざまな国際空港や航空会社を通じた実際の「実地」路上テストで複数のテストが行​​われ、実行されました。機能的にも物理的にも非常に良好です。テストと認定の詳細については、",
    reply2: "ここをクリック",
    back: "戻る",
  },
  es: {
    reply1:
      'Las primeras candados de equipaje inteligentes eGeeTouch® del mundo montadas en el equipaje facturado y en la maleta de mano se sometieron a múltiples pruebas durante más de un año, desde mayo de 2014 hasta junio de 2015, en pruebas reales en carretera "en vivo" en varios aeropuertos y aerolíneas internacionales y se realizaron tremendamente bien tanto en integridad funcional como física. Para obtener más información sobre pruebas y certificaciones, ',
    reply2: "haga clic aquí",
    back: "Atrás",
  },
});

class Q23_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <a
          href="http://www.egeetouch.com/support/certificates"
          target="_blank"
          style={{ textDecoration: "underline", color: "black" }}
        >
          {localizationStrings.reply2}
        </a>
        {this.state.language === "ja" ? "。" : "."}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q23_component;
